import { useFormik } from "formik";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import * as Yup from "yup";
import { useDispatch, useSelector } from "react-redux";

import CommonInput from "../../Components/CommonForms/CommonInput";
import CommonButton from "../../Components/Buttons/CommonButton";
import classes from "./Login.module.css";
import {
  AcceptNumbersandLetters,
  AvoidSpace,
  CatchMessage,
  JSONtoformdata,
  PreventPasting,
} from "../../Shared/Methods";
import { ProjectID, lengths } from "../../Shared/Constants";
import { handleloading } from "../../Store/Redux/Reducers/Dashboardreducers";
import { AllUrl, SaltKeys } from "../../Services/ServiceConstants";
import { LoginApi } from "../../Services/ApiServices";
import { setCookie } from "../../Store/Storage/Cookies";
import { UpdateLoginDate } from "../../Store/Redux/Reducers/Authreducers";
import userIcon from "../../Assests/Images/Vector (74).svg";
import passwordIcon from "../../Assests/Icons/password.svg";
import Loader from "../../SharedComponents/Loader/Loader";
import instance from "../../Services/Axios";
import { useEffect } from "react";

const validation = Yup.object().shape({
  user_code: Yup.string().required("User Name is required"),
  password: Yup.string().required("Pasword is required"),
  organization_code: Yup.string().required("Organization Code is required"),
});

var sha1 = require("sha1");

function Login() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { LoginData } = useSelector((state: any) => state.Auth);
  const { loading } = useSelector((state: any) => state.Dashboard);
  const location = useLocation();

  const {
    values,
    errors,
    touched,
    setFieldValue,
    handleSubmit,
    handleBlur,
    setValues,
  } = useFormik({
    initialValues: {
      user_code: "",
      password: "",
      device_type: 3,
      organization_code: "",
    },
    validationSchema: validation,
    onSubmit: (value) => {
      handleLogin();
    },
  });

  useEffect(() => {
    setValues({
      user_code: "mae123",
      password: "123",
      device_type: 3,
      organization_code: "DEMO1",
    });
  }, []);

  const handleLogin = () => {
    dispatch(handleloading(true));

    const finalObj = {
      ...values,
      auth_code: sha1(AllUrl.SALT_KEY + values.user_code),
      ...ProjectID,

      // authcode: sha1(SaltKeys?.developmentSaltKey + values.user_code),
    };

    LoginApi(JSONtoformdata(finalObj))
      .then((res) => {
        if (res?.data?.status === 1) {
          navigate("/dashboard");
          toast.success(res?.data?.msg);
          instance.defaults.baseURL = res?.data?.base_url;
          setCookie("MconnectEnergyLoginData", res?.data);
          dispatch(UpdateLoginDate(res?.data));
          // window.location.reload();
        } else if (res?.data?.status === 0) {
          toast.error(res?.data?.msg);
        }
      })
      .catch((err) => {
        CatchMessage(err);
      })
      .finally(() => dispatch(handleloading(false)));
  };

  // useEffect(() => {
  //   const disableBackNavigation = (event: PopStateEvent) => {
  //     event.preventDefault();
  //     // setconfirmation(true);
  //     navigate("/");
  //   };

  //   window.history.pushState(null, "/");
  //   window.addEventListener("popstate", disableBackNavigation);

  //   return () => {
  //     window.removeEventListener("popstate", disableBackNavigation);
  //   };
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, []);

  return (
    <>
      <Loader isLoader={loading} />
      {/* <div className={`row ${classes.login_container}`}>
        <div
          className={`col-lg-6 col-md-5 col-0 p-0 ${classes.loginImageContainer}`}
        >
          <img src={loginImg} alt="loginImg" />
        </div>

        <div
          className={`col-lg-6 col-md-7 col-12 p-md-0 ${classes.contentContainer}`}
        >
          <div className={classes.login_water_marker_img}> */}
      <p className={classes.login_text}>Login</p>
      <form
        onSubmit={handleSubmit}
        className={`primaryInput ${classes.login_form_container}`}
        id="remove_image"
      >
        {/* <div style={{ display: "flex", flexDirection: "column", gap: "15px" }}>
          <img
            className={`img-auto ${classes.appLogo}`}
            src={appLogo}
            alt="appLogo"
          />
          <p className={classes.appText}>M-POWER</p>
        </div> */}
        {/* <p>Login</p> */}
        <CommonInput
          name="organization_code"
          value={values?.organization_code}
          onChange={(e) => {
            if (AcceptNumbersandLetters(e.nativeEvent.data)) {
              setFieldValue("organization_code", e.target.value);
            }
          }}
          required={true}
          error={errors}
          touched={touched}
          labelname={"Organization Code"}
          maxLength={lengths.OrganizationCode}
          isInvalid={
            errors.organization_code && touched.organization_code ? true : false
          }
          onBlur={handleBlur}
          // preIcon={passwordIcon}
          type="text"
          // preIconStyles={{
          //   height: "22px",
          // }}
        />
        <CommonInput
          name="user_code"
          value={values?.user_code}
          onChange={({ target }) => {
            if (!target.value.includes(" ")) {
              setFieldValue("user_code", target.value);
            }
          }}
          required={true}
          error={errors}
          touched={touched}
          labelname={"User Name"}
          maxLength={lengths.Names}
          onKeyDown={AvoidSpace}
          isInvalid={errors.user_code && touched.user_code ? true : false}
          onBlur={handleBlur}
          preIcon={userIcon}
          preIconStyles={{
            width: "19px",
            marginTop: "2px",
          }}
        />

        <CommonInput
          name="password"
          value={values?.password}
          onChange={({ target }) => {
            // if (!target.value.includes(" ")) {
            setFieldValue("password", target.value);
            // }
          }}
          required={true}
          error={errors}
          touched={touched}
          labelname={"Password"}
          onPaste={PreventPasting}
          maxLength={lengths.Password}
          onKeyDown={AvoidSpace}
          isInvalid={errors.password && touched.password ? true : false}
          onBlur={handleBlur}
          preIcon={passwordIcon}
          type="password"
          preIconStyles={{
            height: "22px",
          }}
        />
        <div className={classes.forgot_password_container}>
          <p onClick={() => navigate("/forgotpassword")}>
            {/* Forgot Credential Password? */}
            Forgot Password?
          </p>
        </div>

        <div className={classes.btn_container}>
          <CommonButton
            name="Login"
            style={{
              border: "none",
              width: "100px",
              height: "38px",
              color: "white",
              borderRadius: "7px",
            }}
            onClick={() => handleSubmit}
            type="submit"
            classname="submit_btn"
          />
        </div>
        <p style={{ textAlign: "center", fontWeight: "500" }}>
          Don't have an account?{" "}
          <span
            style={{ color: "#20a2a0", cursor: "pointer" }}
            onClick={() => navigate("/register")}
          >
            Signup
          </span>
        </p>
      </form>
      {/* </div>
        </div>
      </div> */}
    </>
  );
}

export default Login;
